import * as FiIcons from 'react-icons/fi';

const { FiShield, FiHeart, FiAward, FiGitMerge, FiMoon, FiBriefcase } = FiIcons;

export const MENTORS = {
  butler: {
    key: 'butler',
    name: 'The Butler',
    tier: 'Essential',
    domain: 'Initial Boost',
    spsGrant: 750,
    dailySeeds: 6,
    seedCost: 0,
    stripePrice: null,
    isOwnedDefault: true,
    description: 'Provides a foundational SPS boost and a daily seed allowance to get your garden started.',
    icon: FiBriefcase,
    image: 'https://cdn.midjourney.com/b4301a8c-ee74-44a2-9748-f6eed56fbfd3/0_0.webp'
  },
  rhino: {
    key: 'rhino',
    name: 'The Rhino',
    tier: 'Tier 1',
    domain: 'Aggressive Growth',
    spsGrant: 1000,
    dailySeeds: 5,
    seedCost: 500000000, // 500M
    stripePrice: '$9.99',
    stripePriceId: 'price_rhino_1',
    description: 'A powerful mentor for rapid, early-game seed accumulation.',
    icon: FiShield,
    upgradeBaseCost: 250000000,
    upgradeCostMultiplier: 1.5,
    image: 'https://cdn.midjourney.com/b744b2a0-2bde-41ea-bd3b-4fd6cc7dab09/0_0.webp'
  },
  panda: {
    key: 'panda',
    name: 'The Panda',
    tier: 'Tier 1',
    domain: 'Balanced Expansion',
    spsGrant: 1250,
    dailySeeds: 7,
    seedCost: 600000000, // 600M
    stripePrice: '$9.99',
    stripePriceId: 'price_panda_1',
    description: 'A balanced mentor focused on sustainable growth and daily returns.',
    icon: FiHeart,
    upgradeBaseCost: 300000000,
    upgradeCostMultiplier: 1.5,
    image: 'https://cdn.midjourney.com/600adc72-2940-4247-8464-a47314a49ccc/0_0.webp'
  },
  leo: {
    key: 'leo',
    name: 'Leo the Leader',
    tier: 'Tier 2',
    domain: 'Strategic Investment',
    spsGrant: 2000,
    dailySeeds: 10,
    seedCost: 1000000000, // 1B
    stripePrice: '$14.99',
    stripePriceId: 'price_leo_1',
    description: 'A strategic mentor who provides significant boosts to both SPS and daily income.',
    icon: FiAward,
    upgradeBaseCost: 500000000,
    upgradeCostMultiplier: 1.5,
    image: 'https://cdn.midjourney.com/7fadfd41-d965-484f-bb5d-ef302e35699c/0_0.webp'
  },
  octomind: {
    key: 'octomind',
    name: 'Octomind',
    tier: 'Tier 2',
    domain: 'Exponential Power',
    spsGrant: 3000,
    dailySeeds: 8,
    seedCost: 1500000000, // 1.5B
    stripePrice: '$19.99',
    stripePriceId: 'price_octomind_1',
    description: 'An elite mentor focused on maximizing your passive generation capabilities.',
    icon: FiGitMerge,
    upgradeBaseCost: 800000000,
    upgradeCostMultiplier: 1.5,
    image: 'https://cdn.midjourney.com/7fadfd41-d965-484f-bb5d-ef302e35699c/0_2.webp'
  },
  xillian: {
    key: 'xillian',
    name: 'Xillian',
    tier: 'Prestige',
    domain: 'Advanced Tactics',
    spsGrant: 5000,
    dailySeeds: 15,
    seedCost: 3000000000, // 3B
    stripePrice: '$49.99',
    stripePriceId: 'price_xillian_1',
    prestigeRequired: 1,
    description: 'An enigmatic mentor who only appears to those who have transcended their garden.',
    icon: FiMoon,
    upgradeBaseCost: 1000000000,
    upgradeCostMultiplier: 1.6,
    image: 'https://cdn.midjourney.com/7fadfd41-d965-484f-bb5d-ef302e35699c/0_3.webp'
  },
};